export const company_details = {
  name: 'Esto Networks Private Limited',
  address:"Sai  Road, Baddi, Himachal Pradseh"
};
